import { render, staticRenderFns } from "./tableItem.vue?vue&type=template&id=c4a758c2&scoped=true"
import script from "./tableItem.vue?vue&type=script&lang=js"
export * from "./tableItem.vue?vue&type=script&lang=js"
import style0 from "./tableItem.vue?vue&type=style&index=0&id=c4a758c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a758c2",
  null
  
)

export default component.exports